import { API as _API } from './Api';
const API = _API.getInstance();
export { API };
export { default as Auth } from './Auth';
export { default as SSO } from './Sso';


// WEBPACK FOOTER //
// ./src/helper/api/index.js